export function isJsonWidget(schema: { widget?: { id?: string } } | undefined): boolean {
  return schema?.widget?.id === 'json';
}

export function parseJsonText(raw: unknown): { ok: true; value: unknown } | { ok: false; error: string } {
  if (raw == null || raw === '') {
    return { ok: true, value: {} };
  }
  if (typeof raw === 'object') {
    return { ok: true, value: raw };
  }
  const text = `${raw}`.trim();
  if (!text) {
    return { ok: true, value: {} };
  }
  try {
    return { ok: true, value: JSON.parse(text) };
  } catch (err) {
    return { ok: false, error: `${(err as Error)?.message || err}` };
  }
}

export function stringifyJsonValue(value: unknown): string {
  if (value == null || value === '') {
    return '';
  }
  if (typeof value === 'string') {
    const parsed = parseJsonText(value);
    if (!parsed.ok) {
      return value;
    }
    try {
      return JSON.stringify(parsed.value, null, 2);
    } catch {
      return value;
    }
  }
  try {
    return JSON.stringify(value, null, 2);
  } catch {
    return '';
  }
}

export function jsonStoredValue(raw: unknown): string {
  if (raw == null) {
    return '';
  }
  if (typeof raw === 'string') {
    return raw;
  }
  try {
    return JSON.stringify(raw);
  } catch {
    return '';
  }
}
